<template>
  <layout-content-horizontal-nav :nav-menu-items="navMenuItems">
    <!-- Default Slot -->
    <slot></slot>

    <!-- Navbar -->
    <template #navbar>
      <div
        class="navbar-content-container"
      >
        <div class="d-flex align-center">
          <v-icon
            v-if="$vuetify.breakpoint.mdAndDown"
            class="me-3"
            @click="toggleVerticalNavMenuActive"
          >
            {{ icons.mdiMenu }}
          </v-icon>
          <div v-if="$can('can_see_dollar_and_profit')">
            <span class="ml-1">قیمت دلار :</span>
            <span class="error--text fa-font">{{ $store.state.info.dollar ? numberFormat($store.state.info.dollar) : $store.state.info.dollar }}</span>
          </div>
          <div
            v-if="!$vuetify.breakpoint.mdAndDown && $can('can_see_dollar_and_profit')"
          >
            <span class="mr-1 ml-1"> ضریب سود :</span>
            <span class="error--text fa-font">{{ $store.state.info.percent }}</span>
            <span class="error--text fa-font">%</span>
          </div>
        </div>

        <!-- Right Content: I18n, Light/Dark, Notification & User Dropdown -->
        <div class="d-flex align-center">
          <return-notification-button></return-notification-button>
          <app-bar-note></app-bar-note>
          <app-bar-theme-switcher></app-bar-theme-switcher>
          <app-bar-user-menu class="ms-2"></app-bar-user-menu>
        </div>
      </div>
      <v-overlay
        :value="$store.state.app.shallContentShowOverlay"
        z-index="5"
        absolute
        class="system-bar-overlay"
      ></v-overlay>
    </template>

    <!-- Slot: footer -->
    <template #footer>
      <div class="d-flex justify-space-between">
        <span>تمامی حقوق متعلق است به <a
          href="https://themeselection.com"
          class="text-decoration-none"
        >{{ $t('AppName') }}</a><span class="d-none d-md-inline"></span></span>
        <div class="d-flex align-center">
          <span></span>
          <v-icon
            color="error"
            class="ms-2"
          >
            {{ icons.mdiHeartOutline }}
          </v-icon>
        </div>
      </div>
    </template>

    <!-- App Content -->
    <template #v-app-content>
      <app-customizer class="d-none d-md-block"></app-customizer>
    </template>
    <notification></notification>
  </layout-content-horizontal-nav>
</template>

<script>
import LayoutContentHorizontalNav from '@core/layouts/variants/content/horizontal-nav/LayoutContentHorizontalNav.vue'
import AppCustomizer from '@core/layouts/components/app-customizer/AppCustomizer.vue'
import AppBarNote from '@core/layouts/components/app-bar/AppBarNote.vue'
// App Bar Components

import AppBarThemeSwitcher from '@core/layouts/components/app-bar/AppBarThemeSwitcher.vue'
import themeConfig from '@themeConfig'
import { mdiHeartOutline } from '@mdi/js'
import navMenuItems from '@/navigation/horizontal'
import AppBarUserMenu from '@/components/AppBarUserMenu.vue'
import Notification from '@/layouts/variants/components/Notification.vue'
import ReturnNotificationButton from '@/layouts/variants/components/ReturnNotificationButton.vue'

export default {
  components: {
    Notification,
    ReturnNotificationButton,
    LayoutContentHorizontalNav,
    AppCustomizer,
    AppBarNote,
    // App Bar Components
    AppBarThemeSwitcher,
    AppBarUserMenu,
  },
  setup() {
    const numberFormat = number => number.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')

    return {
      navMenuItems,
      numberFormat,
      // App Config
      appName: themeConfig.app.name,
      appLogo: themeConfig.app.logo,

      // Icons
      icons: {
        mdiHeartOutline,
      },
    }
  },
}
</script>

<style lang="scss" scoped>
.app-title {
  font-size: 1.25rem;
  font-weight: 600;
}

.navbar-content-container {
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-grow: 1;
  position: relative;
}
</style>
